import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { ViewWillEnter, IonContent } from "@ionic/angular";
import { CanActivate, Router } from "@angular/router";
import { EmployeeListService } from "../../../../common/services/employee-listing.service";
import { RequestParams } from "../../../../common/rest-api/models/request-params";
import { GtrakAuthService } from "../../../../../app/features/authentication/services/gtrak-auth.service";
import { ToasterService } from "../../../../common/services/toaster.service";
import { AccountManagementService } from "../../../account-management/services/account-management.service";
import { WebLoginDept } from "../../../account-management/models/web-login-dept.model";
import { ChangeDetectorRef } from '@angular/core';
import { isNumber } from "angular-pipes/utils/utils";
//Test data for ngxtable
const testData = require("../../../../common/test-data/report-data.json");

@Component({
  selector: "app-garment-listing-page",
  templateUrl: "garment-listing.page.html",
  styleUrls: ["./garment-listing.page.scss"],
})
export class GarmentListingPage implements ViewWillEnter, OnInit {
  lastName: string;
  garmentCode: string;
  @ViewChild(IonContent) content!: IonContent;
  public rows: any;

  currentRoute: string;

  totalPages: number = 0;
  totalElements: number = 0;

  requestParams: any;

  currPage: number;
  pageSize: number;
  costCenterString: string;
  submitting: boolean;
  seachByGarmentCode: boolean = false
  loginDepts: WebLoginDept[];
  selectedCostCenter: string;
  customerCode: string;
  departmentCode: string;
  loaded: boolean;
  loadingData: boolean = false;
  constructor(
    private router: Router,
    private employeeListService: EmployeeListService,
    public authService: GtrakAuthService,
    public toasterService: ToasterService,
    private cd: ChangeDetectorRef,
    private accountManagementService: AccountManagementService
  ) {
    this.currentRoute = null;
  }

  async ngOnInit(): Promise<void> {
    this.loaded = false;
    if (this.authService.user?.isDriver) {
      this.router.navigate(["/route"]);
    }
    this.customerCode = this.authService.user.customerCode;

    //if cost center user get all the cost centers associated with that user
    // await this.accountManagementService
    //   .GetCostCenters(this.authService.user.id)
    //   .then((res) => {
    //     const allOption = {
    //       login: '',
    //       customerCode: '',
    //       departmentCode: 'All'
    //     } as any;

    //     this.loginDepts = [allOption, ...res];
    //   });
    //await this.loadCostCenters();
    this.requestParams = new RequestParams();

    if (!this.authService.user.canViewGarmentListing) {
      this.router.navigate([this.authService.user.homeLocation]);
    }
    if (this.authService.user.isWearer) {
      const wearerRoute = `/garment-listing/employee/${this.authService.user.employeeCode}/${this.authService.user.customerCode}/${this.authService.user.departmentCode}`;
      this.router.navigate([wearerRoute]);
    }

    if (this.authService.user.isCustomerUser) {
      this.requestParams.filters.CustomerCode =
        this.authService.user.customerCode;
    } else if (this.authService.user.isEmployeeUser) {
      this.requestParams.filters.EmployeeCode =
        this.authService.user.employeeCode;
    }

    this.rows = [];
    this.currentRoute = this.router.url;

    this.currPage = 1;

    if (localStorage.getItem("pageSize") != null) {
      this.pageSize = Number(localStorage.getItem("pageSize"));
    }
    else {
      this.pageSize = 500;
    }
    this.costCenterString = (this.loginDepts || [])
      .map(c => c.departmentCode)
      .filter(code => code !== 'All')
      .join(',');
    if (this.costCenterString != null && this.costCenterString != "") {
      this.requestParams.filters.CostCenter = this.costCenterString;
      //Aloha added 18/06/2026 - to filter by username when user is cost center user
      this.requestParams.filters.UserName = this.authService.user.id;
    }

    // For the listing view, we want to exclude any inactive employees.
    this.requestParams.filters.ExcludeInactive = true;
    this.requestParams.setOrdering("LastName", "asc");
    // 17/06Aloha commented this code to avoid loading customers on page load, as it was causing issues with cost center users
    //await this.getCustomers();
    //this.loaded = true;
  }

  async ionViewWillEnter(): Promise<void> {
    this.loaded = false;
    await this.loadCostCenters();
    if (localStorage.getItem("pageSize") != null) {
      this.pageSize = Number(localStorage.getItem("pageSize"));
    }
    else {
      this.pageSize = 500;
    }
    if (this.requestParams != undefined) {
      this.lastName = '';
      this.garmentCode = '';
      if (!this.authService.user.isCostCenterUser) {
        delete this.requestParams.filters.CostCenter;
        delete this.requestParams.filters.UserName;
      }
      delete this.requestParams.filters.LastName;
      delete this.requestParams.filters.StopCode;
      delete this.requestParams.filters.StopOrLastName;
      this.requestParams.setPaging(this.currPage, this.pageSize);

      if (this.authService.user.isWearer) {
        const wearerRoute = `/garment-listing/employee/${this.authService.user.employeeCode}/${this.authService.user.customerCode}/${this.authService.user.departmentCode}`;
        this.router.navigate([wearerRoute]);
      }

      //17/06Aloha commented this code to avoid loading customers on page load, as it was causing issues with cost center users
      // await this.getCustomers();
      //Aloha added 17/06/2026 - to load data based on cost center user or not
      if (this.authService.user?.isCostCenterUser) {
        await this.getDataCostCenter();
      } else {
        await this.getDataByLastName();
      }
      this.loaded = true;
      //this.rows = [...this.rows]; 
    }

  }
  async loadCostCenters() {

    const res = await this.accountManagementService
      .GetCostCenters(this.authService.user.id);

    const allOption = {
      login: '',
      customerCode: '',
      departmentCode: 'All'
    } as any;

    this.loginDepts = [allOption, ...res];

    this.costCenterString = (this.loginDepts || [])
      .map(c => c.departmentCode)
      .filter(code => code !== 'All')
      .join(',');
  }
  async getCustomers(): Promise<void> {
    this.loaded = false;
    this.submitting = true;
    this.requestParams.setPaging(this.currPage, this.pageSize);
    var employees = await this.employeeListService.query(this.requestParams);
    if (employees != null) {

      this.totalElements = employees.totalRecords;
      this.totalPages = employees.totalPages;
      this.rows = employees.results;
      this.submitting = false;
    }
    this.loaded = true;
  }


  async getGarment(): Promise<void> {
    this.router.navigate([
      this.currentRoute + "/garment-code/" + this.garmentCode,
    ]);
  }

  async getDataByLastName(): Promise<void> {
    this.loaded = false;
    this.lastName = this.lastName ?? "";

    if (this.requestParams.filters.LastName)
      delete this.requestParams.filters.LastName;
    if (this.requestParams.filters.StopCode)
      delete this.requestParams.filters.StopCode;
    if (this.requestParams.filters.CostCenter)
      delete this.requestParams.filters.CostCenter;
    delete this.requestParams.filters.UserName
    if (this.requestParams.filters.UserName)
      delete this.requestParams.filters.UserName;
    if (this.requestParams.filters.StopOrLastName)
      delete this.requestParams.filters.StopOrLastName;
    if (this.requestParams.filters.DeliveryAddress1)
      delete this.requestParams.filters.DeliveryAddress1;
    this.currPage = 1;

    if (this.lastName && (this.lastName.length > 0)) {
      if (!this.authService.user.isCostCenterUser) {
        if (Number(this.lastName)) {
          this.requestParams.filters.DeliveryAddress1 = this.lastName;
        }
        else {
          this.requestParams.filters.LastName = this.lastName;
        }
      }
      else {
        this.requestParams.filters.StopOrLastName = this.lastName;
      }
      this.requestParams.setOrdering("LastName", "asc");
    }

    await this.getCustomers();
    this.loaded = true;
  }

  async getDataByGarmentCode(): Promise<void> {
    this.loaded = false;
    if (!this.garmentCode) {
      this.loaded = true;
      return;
    }
    if (this.garmentCode.trim() === "") return;
    await this.getGarment();
    this.loaded = true;
  }

  getDataByCustomerAndDepartmentCode(): void {
    this.loaded = false;
    if (this.authService.user.customerCode?.length > 0 && this.customerCode !== this.authService.user.customerCode) {
      this.toasterService.presentToast('danger', '', 'Invalid Customer Code', 1600);
      this.customerCode = this.authService.user.customerCode;
      this.loaded = true;
      return;

    }

    if (!this.customerCode && !this.departmentCode) {
      //get all the customers
      //delete the filters first
      if (this.requestParams.filters.CustomerCode)
        delete this.requestParams.filters.CustomerCode;
      if (this.requestParams.filters.DepartmentCode)
        delete this.requestParams.filters.DepartmentCode;
      if (this.requestParams.filters.CostCenter)
        delete this.requestParams.filters.CostCenter;
      if (this.requestParams.filters.UserName)
        delete this.requestParams.filters.UserName;
      if (this.requestParams.filters.UserName)
        delete this.requestParams.filters.UserName;
      if (this.requestParams.filters.LastName)
        delete this.requestParams.filters.LastName;
      if (this.requestParams.filters.StopCode)
        delete this.requestParams.filters.StopCode;
      if (this.requestParams.filters.StopOrLastName)
        delete this.requestParams.filters.StopOrLastName;
      //set the ordering
      this.requestParams.setOrdering("LastName", "asc");

      //set the page
      this.currPage = 1;

      //get the customers
      this.getCustomers();
    } else {
      //delete the filters first
      if (this.requestParams.filters.CustomerCode)
        delete this.requestParams.filters.CustomerCode;
      if (this.requestParams.filters.DepartmentCode)
        delete this.requestParams.filters.DepartmentCode;
      if (this.requestParams.filters.CostCenter)
        delete this.requestParams.filters.CostCenter;
      if (this.requestParams.filters.UserName)
        delete this.requestParams.filters.UserName;
      if (this.requestParams.filters.LastName)
        delete this.requestParams.filters.LastName;
      if (this.requestParams.filters.StopCode)
        delete this.requestParams.filters.StopCode;
      if (this.requestParams.filters.StopOrLastName)
        delete this.requestParams.filters.StopOrLastName;
      //set the filters
      //if just customer code
      if (this.customerCode && !this.departmentCode) {
        this.requestParams.filters.CustomerCode = this.customerCode;
      } else if (!this.customerCode && this.departmentCode) {
        this.requestParams.filters.DepartmentCode = this.departmentCode;
      } else if (this.customerCode && this.departmentCode) {
        this.requestParams.filters.CustomerCode = this.customerCode;
        this.requestParams.filters.DepartmentCode = this.departmentCode;
      }
      //set the ordering
      this.requestParams.setOrdering("LastName", "asc");

      //set the page
      this.currPage = 1;

      //get the customers
      this.getCustomers();
    }

  }


  async getDataCostCenter(): Promise<void> {
    //check if last name has both numbers and letters
    //if it does, then throw error and return
    //else, start search
    //regex to check if string has both numbers and letters

    this.loaded = false;
    const regex = /([a-zA-Z]+[0-9]|[0-9]+[a-zA-Z])[a-zA-Z0-9]*/;
    if (regex.test(this.lastName)) {
      this.toasterService.presentToast(
        "warning",
        "",
        "Please enter either a last name or stop code",
        3000
      );
      this.loaded = true;
      return;
    } else {
      //if last name is a number search by stop code
      if (!isNaN(Number(this.lastName))) {
        //always delete the filters first
        if (this.requestParams.filters.LastName)
          delete this.requestParams.filters.LastName;
        if (this.requestParams.filters.StopCode)
          delete this.requestParams.filters.StopCode;
        if (this.requestParams.filters.CostCenter)
          delete this.requestParams.filters.CostCenter;
        delete this.requestParams.filters.UserName;
        if (this.requestParams.filters.StopOrLastName)
          delete this.requestParams.filters.StopOrLastName;

        if (!this.lastName && this.selectedCostCenter) {
          this.requestParams.filters.CostCenter = this.selectedCostCenter;
        } else if (this.lastName && !this.selectedCostCenter) {
          this.requestParams.filters.StopOrLastName = this.lastName;
        } else if (this.lastName && this.selectedCostCenter) {
          this.requestParams.filters.StopOrLastName = this.lastName;
          this.requestParams.filters.CostCenter = this.selectedCostCenter;
        }
        if (this.requestParams.filters.CostCenter == 'All' || this.requestParams.filters.CostCenter == undefined) {
          if (this.costCenterString != null && this.costCenterString != "") {
            this.requestParams.filters.CostCenter = this.costCenterString;
          }
        }
        this.currPage = 1;
        this.requestParams.setOrdering("LastName", "asc");
        //Aloha added 18/06/2026 - to filter by username when user is cost center user
        this.requestParams.filters.UserName = this.authService.user.id;
        await this.getCustomers();
      } else {
        //always delete the filters first
        if (this.requestParams.filters.LastName)
          delete this.requestParams.filters.LastName;
        if (this.requestParams.filters.StopCode)
          delete this.requestParams.filters.StopCode;
        if (this.requestParams.filters.CostCenter)
          delete this.requestParams.filters.CostCenter;
        delete this.requestParams.filters.UserName;
        if (this.requestParams.filters.StopOrLastName)
          delete this.requestParams.filters.StopOrLastName;

        if (!this.lastName && this.selectedCostCenter) {
          this.requestParams.filters.CostCenter = this.selectedCostCenter;
          //Aloha added 18/06/2026 - to filter by username when user is cost center user
          this.requestParams.filters.UserName = this.authService.user.id;
        } else if (this.lastName && !this.selectedCostCenter) {
          this.requestParams.filters.StopOrLastName = this.lastName;
        } else if (this.lastName && this.selectedCostCenter) {
          this.requestParams.filters.StopOrLastName = this.lastName;
          this.requestParams.filters.CostCenter = this.selectedCostCenter;
        }
        if (this.requestParams.filters.CostCenter == 'All' || this.requestParams.filters.CostCenter == undefined) {
          if (this.costCenterString != null && this.costCenterString != "") {
            this.requestParams.filters.CostCenter = this.costCenterString;
            //Aloha added 18/06/2026 - to filter by username when user is cost center user
            this.requestParams.filters.UserName = this.authService.user.id;
          }
        }
        this.currPage = 1;

        this.requestParams.setOrdering("LastName", "asc");

        await this.getCustomers();
      }
    }
    this.loaded = true;
  }
  async setPage(event: { pageNumber: number, pageSize: number; sortField?: string, sortDirection?: string }): Promise<void> {
    this.loaded = false;
    this.pageSize = event.pageSize;
    this.currPage = event.pageNumber;
    if (event.sortField == "") {
      this.requestParams.setOrdering("LastName", "asc");
    } else {
      this.requestParams.setOrdering(event.sortField, event.sortDirection);

    }

    await this.getCustomers();
    this.content.scrollToTop(100);
    this.loaded = true;
  }
  changeCostCenter(event): void {
    this.selectedCostCenter = event;
  }
  async onStopCodeFilter(stopCode: string) {
    this.loaded = false;
    this.lastName = stopCode;
    this.selectedCostCenter = 'All';
    this.cd.detectChanges();
    this.currPage = 1;
    this.requestParams.filters.StopCode = stopCode;
    this.rows = [];
    this.currentRoute = this.router.url;

    this.currPage = 1;
    if (localStorage.getItem("pageSize") != null) {
      this.pageSize = Number(localStorage.getItem("pageSize"));
    }
    else {
      this.pageSize = 500;
    }

    this.requestParams.filters.ExcludeInactive = true;
    this.requestParams.setOrdering("LastName", "asc");
    await this.getCustomers();
    this.loaded = true
  }

  async onCostCenterFilter(deliveryAddress2: string) {
    this.loaded = false;
    this.selectedCostCenter = deliveryAddress2;
    this.cd.detectChanges();
    this.currPage = 1;
    this.requestParams.filters.CostCenter = deliveryAddress2;
    //Aloha added 18/06/2026 - to filter by username when user is cost center user
    this.requestParams.filters.UserName = this.authService.user.id;
    this.rows = [];
    this.currentRoute = this.router.url;

    this.currPage = 1;
    if (localStorage.getItem("pageSize") != null) {
      this.pageSize = Number(localStorage.getItem("pageSize"));
    }
    else {
      this.pageSize = 500;
    }
    this.requestParams.filters.ExcludeInactive = true;
    this.requestParams.setOrdering("LastName", "asc");
    await this.getCustomers();
    this.loaded = true
  }
  showGarmentSearchBox() {
    this.seachByGarmentCode = true;
  }
  showSearchBox() {
    this.seachByGarmentCode = false;
  }
  onEnterKey(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (this.authService.user?.isCostCenterUser) {
      this.getDataCostCenter();
    } else {
      this.getDataByLastName();
    }
  }
  onEnterKeyGarCode(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.getDataByGarmentCode();
  }

}
